__turbopack_context__.v({
  "acceligent": "w0DrAG_acceligent",
  "audubon": "w0DrAG_audubon",
  "block": "w0DrAG_block",
  "blocks": "w0DrAG_blocks",
  "blue": "w0DrAG_blue",
  "bottom-text": "w0DrAG_bottom-text",
  "green": "w0DrAG_green",
  "learn-rag": "w0DrAG_learn-rag",
  "letter": "w0DrAG_letter",
  "magenta": "w0DrAG_magenta",
  "number": "w0DrAG_number",
  "paragraph": "w0DrAG_paragraph",
  "pink": "w0DrAG_pink",
  "pista": "w0DrAG_pista",
  "primary": "w0DrAG_primary",
  "results": "w0DrAG_results",
  "symbol": "w0DrAG_symbol",
  "target": "w0DrAG_target",
  "text": "w0DrAG_text",
  "title": "w0DrAG_title",
  "yellow": "w0DrAG_yellow",
});
